import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { BasePagination } from "@/store/modules/base-pagination.store";
import { EventReferenceModule } from "@/store/modules/event-reference.module";
import { ReportPaginationModule } from "@/store/modules/report-pagination.store";
import { TicketModule } from "@/store/modules/ticket.store";
import { VehicleModule } from "@/store/modules/vehicle.store";

/**
 * Maps refernces to their respective modules and icons
 * used in RefsSelect
 */
export const RefTypeMap: Map<BackendResourceEnum, { module: BasePagination<any, any>; icon: string }> = (() => {
  const map = new Map();
  map.set(BackendResourceEnum.VEHICLE, { module: VehicleModule, icon: "mdi-car" });
  map.set(BackendResourceEnum.REPORT, { module: ReportPaginationModule, icon: "mdi-wrench-outline" });
  map.set(BackendResourceEnum.EVENT, { module: EventReferenceModule, icon: "mdi-calendar" });
  map.set(BackendResourceEnum.TICKET, { module: TicketModule, icon: "mdi-ticket-outline" });
  map.set("", { module: undefined, icon: "mdi-progress-question" });

  return map;
})();
